module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_02_6DB79_1SB_H2G.dbc6625f.jpg";